import { AnyAction, Reducer } from 'redux';

import { CityControlState } from '../../models/redux/city-control.state';
import {
  GET_CITIES_CONTROL,
  GET_CITIES_CONTROL_ERROR,
  GET_CITIES_CONTROL_CONFIG,
  GET_CITIES_CONTROL_CONFIG_ERROR,
  SET_CITIES_TRIGGERS
} from './city-control.types';

const initialState: CityControlState = {
  controlCities: [],
  loadingCities: false,
  citiesControlConfig: [],
  loadingCitiesConfig: false,
  settingTriggers: false
};

const reducer: Reducer<CityControlState> = (
  state: CityControlState = initialState,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case GET_CITIES_CONTROL:
    case GET_CITIES_CONTROL_ERROR:
    case GET_CITIES_CONTROL_CONFIG:
    case GET_CITIES_CONTROL_CONFIG_ERROR:
    case SET_CITIES_TRIGGERS:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default reducer;
